<template>
  <a-row style="position: absolute;bottom: 0;width: 100%">
    <a-col :span="24" class="txt_copy_right">
      <a href="https://dt.aigcpop.com/agreement/user_service.html" target="_blank"> 用户协议  </a> |
      <a href="https://dt.aigcpop.com/agreement/user_privacy_policy.html" target="_blank"> 隐私政策  </a> |
      版权所有2023<a href="https://aigcpop.com/" target="_blank"> {{ company }} </a> <span @click="showMoreContent">保留所有权</span>。
      <a href="https://beian.miit.gov.cn/" target="_blank"> {{ beian }} </a>
<!--      <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2023034398号-1</a>-->
      <a href="https://www.12377.cn/" target="_blank">12377中央网信办违法和不良信息举报中心</a>
      | 举报邮箱：service@meupop.com
    </a-col>
  </a-row>
</template>

<script>
export default {
  name: 'MyComponent',
  components: {},
  props: [],
  data () {
    return {
      beian: '粤ICP备2023042737号-1',
      company: '嗷呜世界（深圳）网络科技有限公司'
    }
  },
  computed: {},
  mounted () {
    const currentDomain = window.location.hostname // 输出当前加载页面的域名
    if (currentDomain.includes('aigcpop.com')) {
      this.$store.commit('updateIsMeu', false)
      return
    }
    if (currentDomain.includes('test.meupop.com') || currentDomain.includes('www.meupop.com')) {
      this.$store.commit('updateIsMeu', true)
      this.beian = '粤ICP备2023034398号-1'
      this.company = '喵呜宇宙（深圳）人工智能有限公司'
    }
  },
  methods: {
    showMoreContent () {
      this.$store.commit('updateIsMeu', false)
    }
  }
}
</script>

<style>
.txt_copy_right{
  min-height: 40px;
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  color: rgba(255,255,255,0.6);
  line-height: 16px;
  text-align: center;
  padding:10px
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue